// 1000+ Hinglish reviews — generated deterministically from combinators
const FIRST_NAMES = [
  "Priya", "Rakesh", "Suman", "Vinod", "Asha", "Mohit", "Neha", "Ankit", "Pooja", "Sandeep",
  "Kavita", "Imran", "Deepa", "Ravi", "Sneha", "Yogesh", "Aarti", "Lokesh", "Mehak", "Suresh",
  "Bharti", "Naveen", "Tanu", "Karan", "Geeta", "Faisal", "Manju", "Rohit", "Sushma", "Aman",
  "Rashmi", "Vikram", "Sonia", "Pankaj", "Anita", "Gaurav", "Komal", "Dinesh", "Reshma", "Sahil",
  "Madhuri", "Nitin", "Shweta", "Arun", "Anjali", "Jagdish", "Heena", "Manoj", "Latika", "Rajesh",
  "Smita", "Hardik", "Jyoti", "Vipul", "Surbhi", "Anand", "Pinki", "Salman", "Roshni", "Ashok",
  "Beena", "Tarun", "Mamta", "Devendra", "Kiran", "Ramesh", "Nikita", "Aditya", "Shalini", "Rohan",
  "Ujjwal", "Tejas", "Pallavi", "Rajni", "Saif", "Lakshmi", "Sahir", "Shreya", "Akhil", "Kalpana",
  "Tushar", "Sapna", "Bhavesh", "Charu", "Yash", "Reema", "Govind", "Riya", "Sumit", "Sara",
  "Manish", "Aishwarya", "Pratik", "Trisha", "Hemant", "Megha", "Sourav", "Aditi", "Varun", "Ritu",
];

const LAST_INITIALS = [
  "S.", "K.", "M.", "P.", "G.", "T.", "V.", "B.", "R.", "D.",
  "J.", "C.", "A.", "Y.", "L.", "H.", "N.", "O.", "Sh.", "Ku.",
];

const CITIES = [
  ["Pune", "MH"], ["Lucknow", "UP"], ["Kolkata", "WB"], ["Indore", "MP"], ["Hyderabad", "TS"],
  ["Jaipur", "RJ"], ["Surat", "GJ"], ["Ahmedabad", "GJ"], ["Patna", "BR"], ["Bhopal", "MP"],
  ["Nagpur", "MH"], ["Aligarh", "UP"], ["Coimbatore", "TN"], ["Vadodara", "GJ"], ["Mumbai", "MH"],
  ["Ludhiana", "PB"], ["Delhi", "DL"], ["Raipur", "CG"], ["Chandigarh", "CH"], ["Visakhapatnam", "AP"],
  ["Kanpur", "UP"], ["Bengaluru", "KA"], ["Meerut", "UP"], ["Faridabad", "HR"], ["Varanasi", "UP"],
  ["Mysore", "KA"], ["Ranchi", "JH"], ["Agra", "UP"], ["Nashik", "MH"], ["Thane", "MH"],
  ["Jodhpur", "RJ"], ["Amritsar", "PB"], ["Allahabad", "UP"], ["Guwahati", "AS"], ["Bhubaneswar", "OD"],
  ["Cuttack", "OD"], ["Dehradun", "UK"], ["Howrah", "WB"], ["Vijayawada", "AP"], ["Rajkot", "GJ"],
  ["Madurai", "TN"], ["Salem", "TN"], ["Tiruchirappalli", "TN"], ["Hubli", "KA"], ["Solapur", "MH"],
  ["Mangalore", "KA"], ["Jalandhar", "PB"], ["Bareilly", "UP"], ["Moradabad", "UP"], ["Gorakhpur", "UP"],
  ["Gwalior", "MP"], ["Jabalpur", "MP"], ["Udaipur", "RJ"], ["Kota", "RJ"], ["Ajmer", "RJ"],
  ["Jamshedpur", "JH"], ["Dhanbad", "JH"], ["Asansol", "WB"], ["Siliguri", "WB"], ["Durgapur", "WB"],
  ["Srinagar", "JK"], ["Shimla", "HP"], ["Rohtak", "HR"], ["Hisar", "HR"], ["Karnal", "HR"],
  ["Panipat", "HR"], ["Gurgaon", "HR"], ["Noida", "UP"], ["Ghaziabad", "UP"], ["Saharanpur", "UP"],
];

const TEMPLATES = [
  "Kitchen ki chimney {amazing} clean ho gayi. {pehle} scrub karte karte haath dard hota tha. Genuine product.",
  "Bathroom ke tiles ka peela daag 5 min me {gayab}. Buy 1 Get 3 deal mast hai, family use kar rahi hai.",
  "Ek hi bottle se gas stove, sink, basin sab clean kiya. Smell bhi nahi, kids ke around {safe}.",
  "Delivery 4 din me aayi COD me. Product solid hai, oil ke daag dho deta hai bina mehnat.",
  "Maine pehle Vim, Cif sab try kiya. Yeh Japanese formula sach me {alag} level ka hai.",
  "Car ke interior plastic aur dashboard pe bhi try kiya — shine aa gayi! Multi-purpose hai sach me.",
  "Saas ne pehle mana kiya tha online order ka. Ab khud order karne keh rahi hai 😂.",
  "Office ka pantry kitchen sink kaala ho gaya tha — 10 min me sparkling. Sabne pucha kahaan se laaya.",
  "Diwali ki cleaning ke liye liya tha. 4 bottle ₹499 me — paisa vasool. Refund ki zarurat nahi padi.",
  "Bathroom ka geyser ke neeche jo paani ka daag tha, hata diya. Family ko bhi recommend kiya.",
  "Marble floor pe try kiya, no scratch, no streak. Maid bhi khush hai ab.",
  "Quality dekh ke mai aur 4 bottle order karne ja raha hu apne dukaan ke liye.",
  "COD me bhi packaging neat. Sealed bottle. Hindi instructions samajhne me asaani hui.",
  "Thoda smell hai but harmful nahi. Kaam ka kaam, ek hi spray me chamak.",
  "Maid ke aane ka time bach gaya. Self-cleaning hai bilkul. Recommend karungi 100%.",
  "Bina dastane ke use kiya, haath bilkul soft hai. Skin friendly hai sach me.",
  "Gas stove pe zid daag the saalon se. Pehli baar ek minute me gaye. Itni khushi hui!",
  "Whole family discount + COD + 7 day refund — trust ke saath buy kiya.",
  "Hostel me 4 friends ke saath divide kiya. Sab khush. 1 bottle 3 mahine chalegi easy.",
  "Mere papa khush hai. Unka favourite product ban gaya hai cleaning ke liye.",
  "Sasta product socha tha duplicate hoga but bilkul genuine niklaa. Japan ka formula sach me {alag} hai.",
  "Granite kitchen counter ka oil layer chala gaya. 4 bottles me ₹499 — value for money.",
  "Pati ne pehle haste mazak udaaya order pe, ab khud ghar me clean karte hai 😂",
  "Office washroom ki shine wapas aa gayi. Bina chemical smell ke. Highly recommended.",
  "Mandir ke brass items pe bhi try kiya. Shine first day jaisi aa gayi.",
  "Delivery thodi late hui par product perfect. Customer care ne call kiya, helpful the.",
  "Stainless steel utensils, sink, hood — sab clean. Behan ko bhi gift kiya 1 bottle.",
  "Daily kaam aasaan ho gaya. 5 star, refund ki zarurat nahi padi.",
  "Pehle market ke products try kiye lekin yeh sabse better hai. Worth every rupee.",
  "Toilet seat aur basin chamak gaye. Ghar wali bhi maan gayi finally.",
  "RO ke filter ke aas paas paani ka jamav clean ho gaya. Kamaal hai bhai.",
  "Mein ladka hu, ghar kaam nahi karta tha. Ab maa ko help karna start kiya kyunki ye easy hai.",
  "Daag jo 2 saal se the wo gaye. Mummy ne tareef ki, dil khush ho gaya.",
  "Geyser ka rust aur scale dono gaye. Bahut acha product hai.",
  "Restaurant chalata hu apna, ye product hamesha ke liye stock me rahega.",
  "Sasta hai but quality top class hai. Maine 2 dost ko bhi recommend kar diya.",
  "Saaf safai ka mood nahi tha but ye dekh ke try kiya - chamak gaya bathroom!",
  "Window glass aur mirror sparkling clean. Streaks nahi reh gaye.",
  "Hard water stains shower ke door pe the - 90% gaye. Bahut khush hu.",
  "AC ke filter pe spray kiya, dust easily nikal gayi. Multi-use hai sach me.",
];

const REPLACERS = {
  amazing: ["bilkul nayi jaisi", "ekdum naya jaisi", "showroom jaisi", "polish karne jaise", "naya jaisa"],
  pehle: ["Pehle to", "Ab tak", "Mehengi cleaners se", "Ghar wali roz"],
  gayab: ["gayab", "saaf", "khatam", "remove"],
  safe: ["safe lagta hai", "bilkul safe", "harmless lagta hai", "tension free"],
  alag: ["alag", "next", "premium", "world class"],
};

function pick(arr, seed) {
  return arr[seed % arr.length];
}

function tmpl(t, seed) {
  return t.replace(/\{(\w+)\}/g, (_, k) => pick(REPLACERS[k] || [k], seed));
}

// Deterministic large pool — 1200 unique-ish reviews
function generateReviews(total = 1200) {
  const out = [];
  for (let i = 0; i < total; i++) {
    const fn = pick(FIRST_NAMES, i * 7 + 3);
    const li = pick(LAST_INITIALS, i * 11 + 5);
    const [city, state] = pick(CITIES, i * 13 + 1);
    const tplt = TEMPLATES[(i * 17 + 2) % TEMPLATES.length];
    const text = tmpl(tplt, i * 23 + 5);
    const stars = (i % 9 === 0) ? 4 : 5;
    const daysAgo = (i % 30) + 1;
    out.push({
      name: `${fn} ${li}`,
      city: `${city}, ${state}`,
      stars,
      daysAgo,
      text,
      verified: true,
    });
  }
  // Top 4 reviews carry a real customer-attached photo
  const PHOTOS = [
    "/assets/product/use-bathroom.webp",
    "/assets/product/use-kitchen.webp",
    "/assets/product/use-shelf.webp",
    "/assets/product/use-floor.webp",
  ];
  for (let i = 0; i < Math.min(4, out.length); i++) {
    out[i].photo = PHOTOS[i];
  }
  return out;
}

export const REVIEWS = generateReviews(1200);
